module.exports = __webpack_public_path__ + "img/media (8).7f02eeae.png";